import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhaseFour = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 273,
	height: 182,
	viewBox: "0 0 273 182",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "bg",
			d: "M48 96.7848C48 107.32 56.9265 132.478 76.2357 143.545C95.9518 154.844 112.482 145.39 135.732 145.763C153.294 146.044 164.116 151.042 180.708 145.763C204.185 138.293 229.656 125.486 224.272 103.254C220.527 87.7921 202.694 88.0431 191.599 75.8999C180.531 63.7863 181.718 51.28 168.002 41.7079C138.311 20.9877 102.101 36.5128 74.4206 59.4508C60.3555 71.106 48 86.2499 48 96.7848Z",
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.6003 104.304L49.6802 100.232L54.0605 98.7076L53.6003 104.304Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.964 102.037L55.0438 97.9652L59.4241 96.4409L58.964 102.037Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.5532 99.6824L60.3544 95.8905L64.6161 94.0684L64.5532 99.6824Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.3964 97.0901L65.9639 93.5663L70.1009 91.4833L70.3964 97.0901Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.76 94.4455L71.3276 90.9218L75.4645 88.8388L75.76 94.4455Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.7406 92.1788L76.3081 88.6551L80.445 86.5721L80.7406 92.1788Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.338 89.5344L80.9055 86.0106L85.0425 83.9276L85.338 89.5344Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.5884 86.3609L85.8538 83.2425L89.7851 80.8027L90.5884 86.3609Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.337 83.3928L90.6024 80.2744L94.5337 77.8346L95.337 83.3928Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.559 76.2944L99.4118 73.8939L102.938 70.9124L104.559 76.2944Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.531 79.4708L95.5738 76.7095L99.3095 73.9873L100.531 79.4708Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.153 75.2881L104.428 70.3585L109.059 69.9976L107.153 75.2881Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M159.57 67.6072L156.044 63.1986L160.548 62.0763L159.57 67.6072Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.933 66.4739L161.408 62.0653L165.911 60.943L164.933 66.4739Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.063 64.5848L167.538 60.1763L172.041 59.054L171.063 64.5848Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.599 62.3715L173.495 58.4796L177.801 56.7607L177.599 62.3715Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.897 134.375C158.249 134.539 157.671 133.933 157.878 133.305L163.348 116.66L176.207 130.008L158.897 134.375Z",
			fill: "#FAFAFC"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M158.282 133.434L163.532 117.459L175.401 129.779L158.792 133.97C158.467 134.051 158.179 133.748 158.282 133.434Z",
				stroke: "#CAD0E1",
				strokeOpacity: .05,
				strokeWidth: .84375
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M157.878 133.305C157.671 133.933 158.249 134.539 158.897 134.375L161.948 133.606C160.684 132.731 159.58 131.833 158.643 130.976L157.878 133.305ZM159.078 129.653C160.263 130.782 161.776 132.021 163.599 133.189L166.286 132.511C163.5 130.856 161.327 128.995 159.812 127.42L159.078 129.653ZM160.262 126.049C161.868 127.82 164.496 130.144 168.054 132.065L170.853 131.359C166.063 128.978 162.729 125.815 161.027 123.721L160.262 126.049ZM161.506 122.264L163.348 116.66L176.207 130.008L172.786 130.872C166.816 128.263 162.951 124.277 161.506 122.264Z",
			fill: "#CAD0E1",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M158.596 133.535L163.675 118.08L174.774 129.601L158.71 133.654C158.685 133.66 158.67 133.658 158.659 133.654C158.646 133.65 158.631 133.642 158.617 133.627C158.604 133.613 158.596 133.598 158.593 133.584C158.59 133.574 158.589 133.558 158.596 133.535Z",
				stroke: "#CAD0E1",
				strokeOpacity: .2,
				strokeWidth: 1.5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.791 129.371C175.639 129.513 175.358 129.63 174.848 129.593C174.337 129.556 173.68 129.368 172.911 129.008C171.38 128.29 169.554 126.956 167.826 125.162C166.098 123.368 164.841 121.502 164.192 119.957C163.867 119.182 163.71 118.525 163.699 118.02C163.688 117.515 163.82 117.245 163.972 117.102C164.125 116.959 164.405 116.843 164.916 116.88C165.427 116.917 166.084 117.105 166.852 117.465C168.384 118.183 170.209 119.516 171.938 121.311C173.666 123.105 174.923 124.971 175.571 126.516C175.897 127.291 176.053 127.948 176.064 128.453C176.076 128.958 175.943 129.228 175.791 129.371Z",
			fill: "#FAFAFC",
			stroke: "#CAD0E1",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.937 120.885L176.176 119.489C176.543 119.732 177.538 120.245 178.592 120.351C179.909 120.485 180.248 119.191 180.586 117.897L180.586 117.897C180.857 116.862 181.463 116.751 181.732 116.824C181.834 116.794 182.541 116.965 184.549 117.898C186.556 118.83 186.819 117.855 186.699 117.251C186.534 115.764 187.012 114.971 187.272 114.761C188.43 113.989 190.118 114.699 190.817 115.151L190.583 116.347C190.382 116.275 189.757 116.066 188.87 115.803C187.983 115.54 187.136 116.06 186.923 116.455C186.855 116.58 186.803 117.153 187.084 118.062C187.677 119.979 185.718 119.797 185.017 119.412C185.184 119.516 185.056 119.493 183.21 118.565C181.365 117.637 180.73 118.869 180.644 119.602C180.668 119.97 180.448 120.879 179.373 121.573C178.299 122.267 176.635 121.404 175.937 120.885Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M172.131 127.59C172.431 126.462 173.802 124.266 176.885 124.505C179.967 124.743 180.189 125.056 179.915 125.183C179.632 125.643 179.169 126.507 179.149 127.267C179.128 128.068 179.373 130.378 182.315 130.553C183.33 130.578 184.627 129.91 183.715 127.483C182.839 125.151 182.671 125.148 182.299 125.142C182.284 125.142 182.268 125.142 182.252 125.142C183.754 124.712 187.242 124.687 189.187 128.022L189.52 126.928C188.783 125.34 186.079 122.534 181.164 124.012C179.358 123.165 175.222 122.038 173.131 124.309C172.641 124.898 171.701 126.157 171.855 126.481L172.131 127.59ZM180.994 125.652C181.763 126.039 183.334 127.094 183.467 128.219C182.98 128.741 181.766 129.578 180.812 128.753C179.937 127.996 179.704 127.794 179.607 127.542C179.572 127.45 179.555 127.352 179.531 127.218C179.46 126.815 180.477 126.006 180.994 125.652Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M168.281 122.809L168.041 124.205C169.459 124.374 171.91 123.902 172.493 121.012C172.514 120.211 172.54 119.21 171.467 117.48C171.009 116.867 170.571 115.233 172.483 113.598L173.201 113.316C173.193 113.65 173.254 114.399 173.571 114.728C173.626 114.785 173.68 114.849 173.736 114.915C174.087 115.331 174.509 115.829 175.492 115.077C176.404 114.379 175.855 112.849 175.466 112.171C175.202 111.897 174.531 111.406 173.956 111.632C174.657 110.715 176.812 108.879 179.819 108.875L179.954 107.576C178.125 107.597 174.263 108.454 173.446 111.719C172.728 112.002 171.218 113.025 170.926 114.861C170.634 116.697 170.888 117.632 171.051 117.87L171.92 119.595C172.083 119.833 172.345 120.447 172.087 121.002C171.764 121.695 170.499 123.466 168.281 122.809ZM175.632 113.577C175.438 113.239 174.741 112.694 173.509 113.223C173.696 113.829 174.383 114.748 175.632 113.577Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.503 119.956L166.539 118.554C167.268 118.653 168.016 117.757 168.299 117.296C168.395 116.738 167.221 115.766 166.623 115.35C165.135 114.556 164.694 113.25 164.66 112.696C164.468 110.688 165.791 109.552 166.477 109.236C167.543 108.862 167.963 108.105 168.039 107.773C168.047 107.452 166.984 106.677 166.451 106.33L166.586 105.031C167.39 105.372 167.973 106.402 168.164 106.874C168.764 108.813 167.744 110.003 167.159 110.355C166.541 110.673 165.261 111.469 165.082 112.106C164.902 112.742 165.725 113.391 166.159 113.636C167.2 114.223 167.787 114.846 167.95 115.084C169.733 118.415 167.728 119.72 166.503 119.956Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M185.085 112.902L184.111 111.275L186.595 109.534L187.376 110.756L185.085 112.902Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.75 121.763L198.798 120.18L201.481 121.603L200.717 122.835L197.75 121.763Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.516 93.0096L188.543 91.3821L191.026 89.6418L191.807 90.8637L189.516 93.0096Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.454 103.381L186.711 104.165L185.216 101.547L186.53 100.91L188.454 103.381Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.043 103.837L202.702 102.487L204.69 100.21L205.745 101.212L204.043 103.837Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.902 96.1204L165.928 94.4928L168.412 92.7525L169.193 93.9744L166.902 96.1204Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.361 100.452L170.835 98.6214L173.84 99.1157L173.52 100.525L170.361 100.452Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.194 93.1519L175.668 91.3212L178.673 91.8155L178.352 93.2248L175.194 93.1519Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.131 103.784L171.804 104.051L172.444 106.772L174.282 106.418L173.131 103.784Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.082 112.981L200.754 113.248L201.395 115.969L203.233 115.614L202.082 112.981Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M196.098 99.6332L196.069 100.969L198.901 100.954L198.957 99.1086L196.098 99.6332Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.563 83.8911L176.235 84.158L176.875 86.8791L178.713 86.5249L177.563 83.8911Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.368 83.5134L167.04 83.7803L167.68 86.5014L169.518 86.1472L168.368 83.5134Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.529 106.807L198.629 105.808L196.564 107.72L197.797 109.11L199.529 106.807Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.04 97.2413L182.139 96.243L180.074 98.155L181.307 99.5446L183.04 97.2413Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.38 107.018L160.443 107.269L161.588 110.104L162.812 109.934L162.38 107.018Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.3816 100.756C59.9798 96.978 86.9141 85.6556 103.398 70.5932C121.67 69.2483 162.529 64.4069 179.791 55.7998",
			stroke: "#E2E5EF",
			strokeWidth: .5625
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.2144 70.5335C93.2144 71.156 92.7012 71.6696 92.0569 71.6696C91.4127 71.6696 90.8995 71.156 90.8995 70.5335C90.8995 69.9109 91.4127 69.3973 92.0569 69.3973C92.7012 69.3973 93.2144 69.9109 93.2144 70.5335Z",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.383 50.8885C148.383 51.9284 147.527 52.7803 146.46 52.7803C145.392 52.7803 144.536 51.9284 144.536 50.8885C144.536 49.8487 145.392 48.9968 146.46 48.9968C147.527 48.9968 148.383 49.8487 148.383 50.8885Z",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.078 106.045C69.078 107.085 68.2217 107.937 67.1543 107.937C66.0869 107.937 65.2306 107.085 65.2306 106.045C65.2306 105.006 66.0869 104.154 67.1543 104.154C68.2217 104.154 69.078 105.006 69.078 106.045Z",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.521,
			y1: 70.343,
			x2: 172.521,
			y2: 71.3033,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.521,
			y1: 72.1241,
			x2: 172.521,
			y2: 73.0844,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 171.167,
			y1: 71.7491,
			x2: 172.146,
			y2: 71.7491,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 172.973,
			y1: 71.7491,
			x2: 173.952,
			y2: 71.7491,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 200.776,
			y1: 88.0991,
			x2: 200.776,
			y2: 89.0594,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 200.776,
			y1: 89.8801,
			x2: 200.776,
			y2: 90.8404,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 199.421,
			y1: 89.5051,
			x2: 200.4,
			y2: 89.5051,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 201.227,
			y1: 89.5051,
			x2: 202.207,
			y2: 89.5051,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_1075_1006)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M109.38 62.9352C109.38 62.1068 110.051 61.4352 110.88 61.4352H151.971C152.367 61.4352 152.747 61.592 153.028 61.8714L156.421 65.244L159.961 68.7711C160.244 69.0526 160.402 69.435 160.402 69.8338V124.051C160.402 124.879 159.731 125.551 158.902 125.551H110.88C110.051 125.551 109.38 124.879 109.38 124.051V62.9352Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 132.847,
			y1: 95.6603,
			x2: 151.261,
			y2: 95.6603,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 132.847,
			y1: 91.8824,
			x2: 151.261,
			y2: 91.8824,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 133.23,
			y1: 99.0605,
			x2: 143.215,
			y2: 99.0605,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 119.43,
			y1: 71.4849,
			x2: 132.272,
			y2: 71.4849,
			stroke: "#031A6B",
			strokeOpacity: .5,
			strokeWidth: 1.875,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 119.055,
			y1: 76.7577,
			x2: 151.261,
			y2: 76.7577,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 119.487,
			y1: 80.1713,
			x2: 137.409,
			y2: 80.1713,
			stroke: "#031A6B",
			strokeOpacity: .3,
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 136.686,
			y1: 117.947,
			x2: 151.636,
			y2: 117.947,
			stroke: "#B3BAD3",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M150.817 113.851C150.578 113.974 150.292 113.818 150.269 113.554L150.1 111.606C150.074 111.308 150.394 111.101 150.658 111.244L152.587 112.289C152.85 112.432 152.844 112.81 152.576 112.948L150.817 113.851Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 3.60065,
			height: 25.9094,
			rx: .75,
			transform: "matrix(0.879166 0.476516 -0.486882 0.873468 162.437 88.6678)",
			fill: "#FFB484"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M163.624 89.3109L164.943 90.0259C165.307 90.2233 165.439 90.6766 165.237 91.0384L153.353 112.359C153.151 112.721 152.693 112.854 152.328 112.657L152.196 112.585L163.624 89.3109Z",
			fill: "#F29559"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M138.797 115.827C139.916 115.453 140.654 114.424 141.279 113.632C142.499 112.085 143.342 110.378 143.57 108.536C143.581 108.448 143.588 108.197 143.529 108.272C143.256 108.621 143.162 109.142 143.041 109.531C142.557 111.092 142.117 112.7 142.228 114.323C142.283 115.128 142.851 114.754 143.34 114.356C144.258 113.608 145.209 112.752 145.869 111.832C145.904 111.783 146.091 111.308 145.98 111.554C145.646 112.3 145.287 113.034 145.184 113.832C145.15 114.093 144.952 114.96 145.326 115.142C145.848 115.396 146.565 114.593 146.808 114.345C147.23 113.913 147.569 113.426 147.753 112.891C147.761 112.868 147.672 113.406 147.645 113.526C147.559 113.91 146.988 115.843 148.147 115.654C149.091 115.501 149.49 114.612 150.086 114.122",
				stroke: "#031A6B",
				strokeWidth: .75,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.4 122.39C125.268 118.691 123.872 115.081 122.227 111.586C120.582 108.091 122.079 110.901 119.946 107.661C120.753 107.657 121.424 108.162 122.237 108.179C122.574 107.449 122.727 106.107 123.047 105.363C125.285 108.762 124.196 106.224 125.922 109.891C127.648 113.558 129.111 117.345 130.3 121.225C129.517 120.987 128.735 120.76 127.952 120.544C127.441 121.168 126.924 121.783 126.4 122.39Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.189 107.772C123.213 111.107 124.883 107.777 123.407 111.345C121.93 114.912 120.709 118.583 119.754 122.33C119.202 121.749 118.656 121.158 118.116 120.559C117.344 120.811 116.573 121.074 115.803 121.348C116.805 117.417 118.086 113.566 119.635 109.823C121.184 106.08 119.599 109.24 121.672 105.742C122.028 106.47 122.391 107.191 122.763 107.904C123.574 107.849 124.383 107.805 125.189 107.772Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.082 119.066C122.302 119.064 121.67 118.057 120.951 117.865C120.208 117.667 119.148 118.214 118.497 117.839C117.838 117.46 117.798 116.277 117.263 115.746C116.728 115.215 115.529 115.17 115.148 114.517C114.772 113.873 115.331 112.829 115.134 112.095C114.943 111.384 113.927 110.755 113.929 109.986C113.931 109.217 114.95 108.592 115.145 107.883C115.346 107.149 114.792 106.103 115.171 105.461C115.555 104.81 116.754 104.77 117.292 104.242C117.83 103.714 117.876 102.531 118.537 102.155C119.19 101.784 120.247 102.336 120.991 102.141C121.71 101.952 122.348 100.949 123.128 100.951C123.907 100.953 124.54 101.959 125.258 102.151C126.001 102.35 127.061 101.803 127.712 102.178C128.371 102.557 128.412 103.74 128.946 104.271C129.482 104.802 130.68 104.847 131.061 105.5C131.437 106.144 130.878 107.188 131.075 107.922C131.266 108.632 132.283 109.262 132.281 110.031C132.279 110.8 131.259 111.424 131.065 112.134C130.863 112.868 131.417 113.914 131.038 114.556C130.654 115.207 129.455 115.247 128.917 115.775C128.38 116.303 128.333 117.486 127.672 117.862C127.02 118.233 125.963 117.681 125.219 117.876C124.499 118.064 123.861 119.068 123.082 119.066Z",
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.061 105.5C130.68 104.847 129.526 104.848 128.947 104.271C128.947 104.271 131.261 110.172 128.34 113.04C127.518 113.847 126.003 115.645 123.526 116.047C120.857 116.481 117.409 115.889 117.409 115.889C117.611 116.038 117.842 117.471 118.569 117.904C119.101 118.235 120.395 117.736 121.045 117.91C121.436 118.015 122.353 119.064 123.082 119.065C123.861 119.067 124.499 118.064 125.219 117.876C125.963 117.681 127.02 118.233 127.672 117.862C128.333 117.486 128.38 116.303 128.917 115.774C129.455 115.247 130.654 115.207 131.038 114.556C131.417 113.914 130.864 112.867 131.065 112.134C131.259 111.424 132.279 110.8 132.281 110.031C132.283 109.262 131.267 108.632 131.075 107.922C130.878 107.187 131.437 106.144 131.061 105.5Z",
			fill: "#47998D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.12 103.888C119.698 103.88 116.913 106.615 116.904 109.993C116.896 113.371 119.667 116.119 123.089 116.128C126.511 116.136 129.296 113.401 129.305 110.023C129.313 106.645 126.542 103.897 123.12 103.888ZM123.092 114.904C120.358 114.897 118.138 112.695 118.144 109.996C118.151 107.297 120.383 105.106 123.117 105.112C125.851 105.119 128.071 107.322 128.065 110.02C128.058 112.719 125.826 114.911 123.092 114.904ZM125.516 107.744L121.861 111.333L120.698 110.18C120.457 109.94 120.067 109.939 119.824 110.178C119.582 110.416 119.581 110.801 119.822 111.04L121.424 112.629C121.665 112.869 122.056 112.87 122.298 112.632L126.394 108.609C126.636 108.371 126.637 107.985 126.396 107.746C126.155 107.507 125.758 107.506 125.516 107.744Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			filter: "url(#filter1_d_1075_1006)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M152.591 69.0224L160.254 69.4001L152.208 61.4666L152.591 69.0224Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("line", {
				x1: .1875,
				y1: -.1875,
				x2: 4.62768,
				y2: -.1875,
				transform: "matrix(-0.708096 0.706116 -0.715967 -0.698134 170.942 73.178)",
				stroke: "#CAD0E1",
				strokeWidth: .375,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("line", {
				x1: .1875,
				y1: -.1875,
				x2: 4.62768,
				y2: -.1875,
				transform: "matrix(-0.708096 0.706116 -0.715967 -0.698134 199.293 90.8032)",
				stroke: "#CAD0E1",
				strokeWidth: .375,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.62257,
			y2: -.5625,
			transform: "matrix(0.712043 0.702136 -0.712043 0.702136 75.5844 66.017)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.62257,
			y2: -.5625,
			transform: "matrix(0.712043 0.702136 -0.712043 0.702136 79.6481 70.0238)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.62257,
			y2: -.5625,
			transform: "matrix(0.712043 -0.702136 0.712043 0.702136 76.6681 72.9624)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 3.62257,
			y2: -.5625,
			transform: "matrix(0.712043 -0.702136 0.712043 0.702136 80.7316 68.9553)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 14.3057,
			y2: -.5625,
			transform: "matrix(-0.709683 0.704521 -0.714395 -0.699743 70.0452 81.8839)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5625,
			y1: -.5625,
			x2: 14.3057,
			y2: -.5625,
			transform: "matrix(-0.709683 0.704521 -0.714395 -0.699743 73.1102 74.7061)",
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("line", {
				x1: .1875,
				y1: -.1875,
				x2: 7.85597,
				y2: -.1875,
				transform: "matrix(-0.709683 0.704521 -0.714395 -0.699743 170.559 74.6891)",
				stroke: "#CAD0E1",
				strokeWidth: .375,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("line", {
				x1: .1875,
				y1: -.1875,
				x2: 7.85597,
				y2: -.1875,
				transform: "matrix(-0.709683 0.704521 -0.714395 -0.699743 198.91 92.3143)",
				stroke: "#CAD0E1",
				strokeWidth: .375,
				strokeLinecap: "round"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M113.513 52.5829C113.513 52.5829 115.128 52.326 115.816 51.6479C116.503 50.9698 116.764 49.3773 116.764 49.3773C116.764 49.3773 117.024 50.9698 117.712 51.6479C118.4 52.326 120.015 52.5829 120.015 52.5829C120.015 52.5829 118.4 52.8398 117.712 53.5179C117.024 54.196 116.764 55.7885 116.764 55.7885C116.764 55.7885 116.503 54.196 115.816 53.5179C115.128 52.8398 113.513 52.5829 113.513 52.5829Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M126.156 39.7383C126.156 39.7383 127.771 39.4814 128.459 38.8033C129.146 38.1252 129.407 36.5327 129.407 36.5327C129.407 36.5327 129.667 38.1252 130.355 38.8033C131.043 39.4814 132.658 39.7383 132.658 39.7383C132.658 39.7383 131.043 39.9952 130.355 40.6733C129.667 41.3514 129.407 42.9439 129.407 42.9439C129.407 42.9439 129.146 41.3514 128.459 40.6733C127.771 39.9952 126.156 39.7383 126.156 39.7383Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M97.8052 48.2324C97.8052 48.2324 101.035 47.7187 102.411 46.3625C103.786 45.0063 104.307 41.8212 104.307 41.8212C104.307 41.8212 104.828 45.0063 106.203 46.3625C107.579 47.7187 110.809 48.2324 110.809 48.2324C110.809 48.2324 107.579 48.7462 106.203 50.1024C104.828 51.4586 104.307 54.6437 104.307 54.6437C104.307 54.6437 103.786 51.4586 102.411 50.1024C101.035 48.7462 97.8052 48.2324 97.8052 48.2324Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M158.721 52.7776C158.721 52.7776 160.244 52.5354 160.892 51.8961C161.541 51.2567 161.786 49.7552 161.786 49.7552C161.786 49.7552 162.032 51.2567 162.68 51.8961C163.329 52.5354 164.851 52.7776 164.851 52.7776C164.851 52.7776 163.329 53.0198 162.68 53.6591C162.032 54.2984 161.786 55.7999 161.786 55.7999C161.786 55.7999 161.541 54.2984 160.892 53.6591C160.244 53.0198 158.721 52.7776 158.721 52.7776Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M116.961 137.024C116.961 137.024 118.484 136.782 119.132 136.142C119.78 135.503 120.026 134.002 120.026 134.002C120.026 134.002 120.272 135.503 120.92 136.142C121.568 136.782 123.091 137.024 123.091 137.024C123.091 137.024 121.568 137.266 120.92 137.905C120.272 138.545 120.026 140.046 120.026 140.046C120.026 140.046 119.78 138.545 119.132 137.905C118.484 137.266 116.961 137.024 116.961 137.024Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "luminosity" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M69.0715 121.157C69.0715 121.157 70.5942 120.915 71.2425 120.275C71.8909 119.636 72.1365 118.135 72.1365 118.135C72.1365 118.135 72.3821 119.636 73.0304 120.275C73.6788 120.915 75.2015 121.157 75.2015 121.157C75.2015 121.157 73.6788 121.399 73.0304 122.038C72.3821 122.678 72.1365 124.179 72.1365 124.179C72.1365 124.179 71.8909 122.678 71.2425 122.038C70.5942 121.399 69.0715 121.157 69.0715 121.157Z",
				fill: "#CAD0E1"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.2937 104.592C84.0532 107.466 83.1199 112.318 80.5605 112.976C78.0011 113.633 74.7848 109.848 74.0253 106.974C73.2658 104.1 74.7249 101.237 77.2843 100.579C79.8437 99.9218 82.5342 101.718 83.2937 104.592Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.6527 102.529C91.0849 105.446 88.1259 109.431 85.5284 108.939C82.931 108.447 81.6788 103.665 82.2466 100.749C82.8144 97.8323 85.3803 95.8666 87.9777 96.3584C90.5752 96.8501 92.2205 99.613 91.6527 102.529Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.2507 113.601L80.4422 112.846L81.2081 112.657L81.9741 113.035L80.2507 113.601Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.9761 109.372L85.4784 108.771L86.2523 108.926L86.779 109.591L84.9761 109.372Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.3236 105.857C74.1321 103.024 76.4308 101.324 76.6224 101.324C76.8433 101.22 77.2252 101.154 77.5801 101.135C77.5801 101.261 77.5801 101.55 76.8139 101.702C75.8561 101.89 76.5113 103.375 75.8561 103.59C75.2814 103.779 74.8345 105.165 74.8983 105.479C75.0899 105.731 75.2048 106.651 74.8983 106.802C74.5918 106.953 74.3747 106.613 74.3236 105.857Z",
			fill: "#EDF2FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.9382 100.973C83.5389 97.778 86.0667 96.9792 87.2556 96.9792C88.3819 96.9792 89.2078 98.0253 87.2556 97.7348C85.3034 97.4444 84.1417 99.6074 83.6411 100.757C83.2657 102.209 82.3375 104.168 82.9382 100.973Z",
			fill: "#A7B4E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.4421 113.035C79.1012 114.735 80.1077 119.608 80.2505 121.158C80.4421 123.235 82.1661 134.569 80.6336 138.536",
			stroke: "#818CB5",
			strokeOpacity: .25,
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.2307 108.879C84.5922 113.098 86.3801 122.442 87.1463 126.069C87.9125 129.695 88.4233 136.017 87.1463 138.725",
			stroke: "#818CB5",
			strokeOpacity: .25,
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_1075_1006",
			x: 106.38,
			y: 59.9352,
			width: 57.0229,
			height: 70.1157,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1.5 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.319965 0 0 0 0 0.338587 0 0 0 0 0.404167 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1075_1006"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1075_1006",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_1075_1006",
			x: 151.083,
			y: 61.0917,
			width: 10.2955,
			height: 10.1835,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .75 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5625 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1075_1006"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1075_1006",
					result: "shape"
				})
			]
		})] })
	]
});
const ForwardRef = forwardRef(SvgPhaseFour);
export { ForwardRef as ReactComponent };
